import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useMetaMask } from '../context/MetaMaskContext';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

function Header() {
  const { loginWithMetaMask, disconnect, metaMask } = useMetaMask();
  const history = useHistory();

  const [isOpen, setIsOpen] = useState(false);

  async function connectToMetaMask() {
    if (!metaMask.isConnected) {
      loginWithMetaMask();
    }
  }

  function formatHideAddress(num: number = 6) {
    const account = metaMask.account;
    if (!account) return;
    return `${account.substr(0, num)}...${account.substr(account.length - num, account.length)}`;
  }

  return (
    <header className="app-header">
      <div className="logo" onClick={() => history.push('/')}>
        Storylines
      </div>
      <div className="header-container">
        <button className="app-btn color-primary" type="button" onClick={connectToMetaMask}>
          {(!metaMask.isConnected && 'Connect with MetaMask') || formatHideAddress()}
        </button>

        {metaMask.isConnected && (
          <Dropdown className="menu" isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
            <DropdownToggle data-toggle="dropdown" tag="span">
              <FontAwesomeIcon className="menu-icon" icon={faEllipsisV} />
            </DropdownToggle>
            <DropdownMenu className="menu-item-container">
              <div
                className="menu-item"
                onClick={async () => {
                  await disconnect();
                  setIsOpen(!isOpen);
                  history.push('/');
                }}
              >
                <span>Disconnect</span>
              </div>
            </DropdownMenu>
          </Dropdown>
        )}
      </div>
    </header>
  );
}

export default Header;
